import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { ShowIfLoggedIn } from '../features/auth/auth_utils';
import LogoutButton from './LogoutButton';

export default function TopNavbarBasic() {
  return (
    <Navbar bg="light" expand="lg" className="shadow-sm fixed-top" style={{zIndex: 1050}}>
      <Container>
        <Navbar.Brand as={Link} to="/">Mutual Fund pNAV Calculator - Early Release</Navbar.Brand>
        <Nav className="ms-auto">
          <ShowIfLoggedIn>
            <Nav.Link as={Link} to="/dashboard">Tracked Schemes</Nav.Link>
            <Nav.Link as={Link} to="/GenAPIkey">Generate API key</Nav.Link>
            <LogoutButton />
          </ShowIfLoggedIn>
        </Nav>
      </Container>
    </Navbar>
  );
}

